import type { TrelloWorkspace } from './trelloTypes';

function getSelectedOrganizationId(workspaces: TrelloWorkspace[]) {
  return workspaces[0]?.atlassianOrganizationId ?? null;
}

function keepSameOrganizationAsFirst(workspaces: TrelloWorkspace[]) {
  const selectedOrganizationId = getSelectedOrganizationId(workspaces);
  return workspaces.filter(
    (workspace) =>
      (workspace.atlassianOrganizationId ?? null) === selectedOrganizationId,
  );
}

export function normalizeTrelloWorkspaceSelection(
  workspaces: TrelloWorkspace[],
  isMultiSelectEnabled: boolean,
): TrelloWorkspace[] {
  if (workspaces.length <= 1) {
    return workspaces;
  }

  return isMultiSelectEnabled
    ? keepSameOrganizationAsFirst(workspaces)
    : workspaces.slice(0, 1);
}

/**
 * Pick the workspace(s) to pre-select when the selector first loads.
 *
 * - No workspaces  → empty selection (nothing to prefill).
 * - One workspace  → auto-select it.
 * - Many workspaces → empty selection.
 */
export function getInitialTrelloWorkspaceSelection(
  workspaces: TrelloWorkspace[],
): TrelloWorkspace[] {
  if (workspaces.length === 1) {
    return [workspaces[0]];
  }
  return [];
}

export function getSelectableTrelloWorkspaces({
  availableWorkspaces,
  selectedWorkspaces,
  isMultiSelectEnabled,
}: {
  availableWorkspaces: TrelloWorkspace[];
  selectedWorkspaces: TrelloWorkspace[];
  isMultiSelectEnabled: boolean;
}): TrelloWorkspace[] {
  if (!isMultiSelectEnabled || selectedWorkspaces.length === 0) {
    return availableWorkspaces;
  }

  const selectedOrganizationId = getSelectedOrganizationId(selectedWorkspaces);
  return availableWorkspaces.filter(
    (workspace) =>
      (workspace.atlassianOrganizationId ?? null) === selectedOrganizationId,
  );
}
